/**
 * Тема публикации из описания поста — для аккаунтов, где заголовок пишут
 * в подписи, а не накладывают текстом на обложку (для остальных тема
 * распознаётся OCR'ом с кадра).
 *
 * Абзац = блок до первой пустой строки; одиночные переносы внутри абзаца
 * схлопываются в пробел. Из абзаца вырезаются #хэштеги и @упоминания.
 */
export function captionTheme(caption: string | null | undefined): string {
  const firstParagraph = (caption ?? '')
    .replace(/\r\n/g, '\n')
    .trim()
    .split(/\n[ \t]*\n/)[0];

  return (firstParagraph ?? '')
    .replace(/[#@][\p{L}\p{N}_.]+/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
